import React, { useState, useEffect } from 'react';


const StatusIndicator = () => {
  const [isConnected, setIsConnected] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setLastUpdate(new Date());
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (date) => {
    return date?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-lg border border-border bg-card">
      <div className={`status-dot ${isConnected ? 'connected' : 'disconnected'}`} />
      <span className="text-xs text-muted-foreground font-medium">
        {isConnected ? formatTime(lastUpdate) : 'Offline'}
      </span>
    </div>
  );
};

export default StatusIndicator;